module.exports = __webpack_public_path__ + "static/media/ret-black-logo.d597d825.svg";